export const seoConfig = {
  //Component (Admin Panel)
  Dashboard: {
    title: "Hirelink | Dashboard",
    description:
      "Manage jobs, candidates, interviews, employers and users easily from Hirelink admin dashboard.",
  },

  a_jobs: {
    title: "Hirelink | All Jobs",
    description:
      "View and manage all job postings, update job details, and control job status in Hirelink admin panel.",
  },

  a_candidates: {
    title: "Hirelink | All Candidates",
    description:
      "Browse all registered candidates, check profiles, manage candidate data and application activity in Hirelink.",
  },

  a_interview: {
    title: "Hirelink | All Interviews",
    description:
      "Manage interview schedules, update interview status, and track interview progress from Hirelink admin panel.",
  },

  a_applicant: {
    title: "Hirelink | All Applicants",
    description:
      "View all job applicants, track applications, and manage candidate selection using Hirelink admin tools.",
  },

  a_employers: {
    title: "Hirelink | All Employers",
    description:
      "Manage employer accounts, verify company details, and monitor employer activity in Hirelink admin dashboard.",
  },

  a_contact: {
    title: "Hirelink | All Contacts",
    description:
      "View and manage all contact queries, support requests and feedback received on Hirelink platform.",
  },

  a_user: {
    title: "Hirelink | All Users",
    description:
      "Manage all platform users, monitor account details, and control access using Hirelink admin panel.",
  },

  a_staff: {
    title: "Hirelink | Staff",
    description:
      "Manage all staff, monitor account details, and control access using Hirelink admin panel.",
  },

  emp_profile: {
    title: "Hirelink | Profile of",
    description:
      "Update your employer profile, company details and account information on Hirelink dashboard.",
  },

  a_login: {
    title: "Hirelink | Admin Login",
    description:
      "Securely login to Hirelink admin panel to manage jobs, candidates, employers and platform activity.",
  },

  a_setting: {
    title: "Hirelink | Admin Setting",
    description:
      "Securely login to Hirelink admin panel to manage jobs, candidates, employers and platform activity.",
  },

  verify: {
    title: "Hirelink | Email Verification",
    description:
      "Verify your email address to activate your Hirelink account and access platform features securely.",
  },

  //Component2 (Candidate Side)
  home: {
    title: "Welcome To Hirelink",
    description:
      "Discover top job opportunities, apply instantly and connect with employers easily using Hirelink.",
  },

  about: {
    title: "Hirelink | About Us",
    description:
      "Learn about Hirelink, our mission and how we connect candidates with the right job opportunities.",
  },

  c_apply: {
    title: "Hirelink | Apply Job",
    description:
      "Apply for your preferred jobs quickly and track your application status on Hirelink platform.",
  },

  companies: {
    title: "Hirelink | Popular Companies",
    description:
      "Explore popular companies hiring on Hirelink and find jobs that match your skills and interests.",
  },

  c_contact: {
    title: "Hirelink | Contact",
    description:
      "Contact Hirelink support team for assistance, queries or feedback related to your account and services.",
  },

  forgot: {
    title: "Forgot Password | Hirelink",
    description:
      "Forgot your Hirelink password? Reset it securely and regain access to your account in just a few simple steps.",
  },

  resetpass: {
    title: "Reset Password | Hirelink",
    description:
      "Create a new password for your Hirelink account securely and continue managing your profile without interruption.",
  },

  help: {
    title: "Hirelink | Help & Support",
    description:
      "Get help for your Hirelink account, job applications, profile updates and other platform support.",
  },

  c_jobdetail: {
    title: "Hirelink | Job Details",
    description:
      "View full job details including role, requirements, salary and location before applying on Hirelink.",
  },

  c_jobs: {
    title: "Hirelink | All Jobs",
    description:
      "Browse all available jobs on Hirelink and filter by category, experience, location and preferences.",
  },

  notification: {
    title: "Hirelink | Notifications",
    description:
      "Stay updated with job alerts, application updates, interview notifications and employer messages on Hirelink.",
  },

  c_privacy: {
    title: "Hirelink | Candidate Privacy & Policies",
    description:
      "Read Hirelink candidate privacy policy and understand how we protect your personal data and information.",
  },

  c_profile: {
    title: "Hirelink | Candidate Profile",
    description:
      "Update your candidate profile, resume, skills and personal details to get better job matches on Hirelink.",
  },

  c_return: {
    title: "Hirelink | Candidate Return Policy",
    description:
      "Review Hirelink candidate return policy and platform rules for services and account usage.",
  },

  signin: {
    title: "Hirelink | Sign In",
    description:
      "Sign in to your Hirelink account to apply jobs, manage profile and track your application progress.",
  },

  signup: {
    title: "Hirelink | Sign Up",
    description:
      "Create your Hirelink account to explore jobs, apply faster and connect with verified employers.",
  },

  c_term: {
    title: "Hirelink | Candidate Terms & Conditions",
    description:
      "Read Hirelink candidate terms and conditions to understand platform usage guidelines and policies.",
  },

  //Component3 (Employer Side)
  e_employers: {
    title: "Hirelink | Employers",
    description:
      "Hire the best talent by posting jobs, managing applicants and scheduling interviews using Hirelink.",
  },

  e_privacy: {
    title: "Hirelink | Employer Privacy & Policies",
    description:
      "Read Hirelink employer privacy policy to understand data security and how your information is protected.",
  },

  e_return: {
    title: "Hirelink | Employer Return Policy",
    description:
      "Check Hirelink employer return policy and service terms for platform usage and support guidelines.",
  },

  e_term: {
    title: "Hirelink | Employer Terms & Conditions",
    description:
      "Read Hirelink employer terms and conditions to know the rules for posting jobs and hiring candidates.",
  },
};
